import React, { useState } from 'react';

import Button from '@components/Common/Button';
import ConfirmModal from '@components/Modals/ConfirmModal';

import { useInvestAssetDelete } from '@hooks/api/portfolio/usePortfolioAPIs';

import { deleteButtonWrapper } from '@styles/common';

/** 포트폴리오 상세 > 투자자산관리 > 투자자산 1줄 삭제 버튼 */
const InvestAssetDeleteButton = ({ id }: { id: number }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const { mutate, isLoading } = useInvestAssetDelete();

  return (
    <>
      <div css={deleteButtonWrapper}>
        <Button label="삭제" handleClick={() => setModalOpen(true)} />
      </div>

      {modalOpen && (
        <ConfirmModal
          title="삭제하시겠습니까?"
          buttonText={['취소하기', '삭제하기']}
          open={modalOpen}
          handleOpen={() => setModalOpen(false)}
          handleCancel={() => setModalOpen(false)}
          handleConfirm={() => mutate(id)}
        />
      )}
    </>
  );
};

export default InvestAssetDeleteButton;
